import React from 'react'
import styled from 'styled-components/macro'
import { ExclamationCircle, CheckmarkCircle, ExclamationTriangle } from '@resultadosdigitais/tangram-react-icons'
import { Text } from '@resultadosdigitais/tangram-components'

const colors = {
  error: {
    background: '--color-red-10',
    border: '--color-red-30',
    color: '--color-red-50',
    icon: '--color-red-50',
  },
  warning: {
    background: '--color-yellow-10',
    border: '--color-yellow-30',
    color: '--color-yellow-50',
    icon: '--color-yellow-50',
  },
  info: {
    background: '--color-primary-10',
    border: '--color-primary-30',
    color: '--color-primary-50',
    icon: '--color-primary-50',
  },
  success: {
    background: '--color-green-10',
    border: '--color-green-30',
    color: '--color-green-50',
    icon: '--color-green-50',
  },
}

const Container = styled.div`
  width: 100%;
  display: inline-block;
  text-align: center;
  background-color: var(${props => colors[props.severity].background});
  border: 1px solid var(${props => colors[props.severity].border});
  border-radius: 4px;
  color: var(${props => colors[props.severity].color});
  text-align: left;
  padding: 11px;
  display: inline-flex;
  align-self: center;

  svg {
    fill: var(${props => colors[props.severity].icon});
    margin-right: 11px;
  }

  span {
    line-height: 24px;
  }
`

function Icon({ severity }) {
  switch (severity) {
    case 'warning':
      return <ExclamationTriangle title={severity} />
    case 'info':
    case 'error':
      return <ExclamationCircle title={severity} />
    case 'success':
    default:
      return <CheckmarkCircle title={severity} />
  }
}

function Alert({ children, severity = 'success' }) {
  return (
    <Container severity={severity}>
      <div>
        <Icon severity={severity} />
      </div>
      <Text as="span" token={Text.tokens.FONT_SIZE_SM_SEMIBOLD} textColor={colors[severity].color}>
        {children}
      </Text>
    </Container>
  )
}

export default Alert
